import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface KpiTileProps {
  label: string;
  value: ReactNode;
  /** Klasse for verdien, f.eks. en TONE_TEXT-farge. */
  valueClassName?: string;
  delta?: ReactNode;
  sub?: ReactNode;
  onClick?: () => void;
}

/** Nøkkeltall-kort på ansattkortet. Klikkbart når `onClick` er satt. */
export function KpiTile({ label, value, valueClassName, delta, sub, onClick }: KpiTileProps) {
  const body = (
    <>
      <span className="text-[11.5px] font-medium uppercase tracking-[0.08em] text-muted-foreground">
        {label}
      </span>
      <span className={cn("font-display text-2xl font-semibold leading-none tabular-nums", valueClassName)}>
        {value}
      </span>
      {delta && <span className="flex items-center gap-1 text-xs">{delta}</span>}
      {sub && <span className="text-xs text-muted-foreground">{sub}</span>}
    </>
  );
  const className = "flex flex-col gap-1.5 rounded-lg border border-border bg-card p-4 text-left";
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(className, "transition-colors hover:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring")}
      >
        {body}
      </button>
    );
  }
  return <div className={className}>{body}</div>;
}
